<template>
  <div class="page-home page">
    <!-- 首页左 -->
    <div class="home-left">
      <!-- 首页左上 -->
      <div class="home-left-first" v-if="false">
        <!-- 方块 -->
        <div class="showEdg-parent" v-for="(item, index) in items" :key="index">
          <showEdg :item="item"></showEdg>
        </div>
      </div>
      <!-- 地图组件 传入位置和图标 -->
      <div class="home-left-map Radius">
        <div class="position-icon">
          <div><img src="@/assets/img/icon/indoor.png">{{$store.state.module1.isChina?'室内项目':'Indoor'}}</div>
        </div>
        <MyMap :positions="ProjectList"  v-if="ProjectList"></MyMap>
      </div>
    </div>
    <!-- 首页右 -->
    <div class="home-right"  v-if="false">
      <div class="home-right-swiper Radius">
        <swiper :items="swiperList"></swiper>
      </div>
      <!-- 原型图表 -->
      <div class="echart-circle Radius">
        <comBox>
          <template v-slot:name>
            <h4>{{$store.state.module1.isChina?'设备详情':'device detail'}}</h4>
          </template>
          <template v-slot:other>
            <h5>...</h5>
          </template>
          <template v-slot:content>
            <echart :data="eData"></echart>
          </template>
        </comBox>
      </div>
      <!-- 新设备创建记录 -->
      <div class="showNewDev Radius">
        <comBox>
          <template v-slot:name>
            <h4>{{$store.state.module1.isChina?'新添设备':'add device'}}</h4>
          </template>
          <template v-slot:other>
            <h5>...</h5>
          </template>
          <template v-slot:content>
            <ul class="createDev-log">
              <li v-for="(todo, index) in todos" :key="index">
                <div>{{todo.devName}}<span>created by</span>{{todo.userName}}</div>
                <span>{{todo.time}}</span>
              </li>
            </ul>
          </template>
        </comBox>
      </div>
    </div>
  </div>
</template>

<script>

import showEdg from '../../components/showEdg/showEdg.vue'
import MyMap from '../../components/map/map.vue'  // 百度地图
// import MyMap from '../../components/map/tdtMap.vue'  // 天地图
import swiper from '../../components/swiper/swiper.vue'
import echart from '../../components/echart/echart.vue'
import comBox from '../../components/comBox/comBox.vue'
import { Mixin } from '../../mixins/index.js'
export default {
  name: 'home',
  mixins: [Mixin],
  components: {
    showEdg,
    MyMap,
    swiper,
    echart,
    comBox
  },
  data () {
    return {
      items: [
        { name: '项目数', num: 12, url: require('../../assets/img/icon/项目数@2x.png') },
        { name: '场所数', num: 78, url: require('../../assets/img/icon/场所数@2x.png') },
        { name: '在线设备', num: 116, url: require('../../assets/img/icon/在线设备@2x.png') },
        { name: '新添设备', num: 7, url: require('../../assets/img/icon/新添设备@2x.png') }
      ],
      position: [
        { point: { lng: 101.000, lat: 38.000 }, url: require('../../assets/img/icon/indoor.png') },
        { point: { lng: 102.000, lat: 41.000 }, url: require('../../assets/img/icon/室外.png') },
        { point: { lng: 103.000, lat: 45.000 }, url: require('../../assets/img/icon/indoor.png') }
      ],
      swiperList: [
        { url: require('../../assets/img/认证中心.png') },
        { url: require('../../assets/img/认证中心.png') },
        { url: require('../../assets/img/认证中心.png') }
      ],
      eData: [
        { value: 1548, name: '在线设备1' },
        { value: 310, name: '新上设备' },
        { value: 234, name: '返厂设备' },
        { value: 135, name: '异常设备' },
        { value: 335, name: '故障设备' }
      ],
      todos: [
        { devName: '2118080213', userName: 'diqin', time: '1 day ago' },
        { devName: '2118080205', userName: 'diqin', time: '1 day ago' },
        { devName: '2118080314', userName: 'asdad', time: '1 day ago' },
        { devName: '01A3900909', userName: 'Saudi', time: '1 day ago' },
        { devName: '01A3900980', userName: '万科', time: '2 day ago' },
        { devName: '2118080314', userName: '育碧', time: '2 day ago' },
        { devName: '01B3700130', userName: '朗诗', time: '3 day ago' }
      ]
    }
  }
}
</script>

<style scoped>

.page-home{
    display:flex;
}
.home-left{
  width:100%;
}
.home-left-first{
display:flex;
}
.showEdg-parent{
margin-right:0.24rem;
}
.home-left-map{
position:relative;
width:100%;
height: calc(100% - 0.2rem);
overflow:hidden;
background: rgba(53,95,255,0.4);
margin-top:0.1rem;
margin-bottom:0.1rem;
}
.position-icon{
  position:absolute;
  right:0.24rem;
  top:0.3rem;
  z-index:999;
  display:flex;
  align-items:center;
}
.position-icon div{
 display:flex;
 align-items:center;
 margin-right:0.24rem;
font-size: 0.1rem;
color:rgba(0,0,0,0.6);
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 600;
}
.position-icon div img{
  width:0.4rem;
  margin-right:0.12rem;
}
.home-right-swiper{
  width:3.6rem;
  height:1.56rem;
  position:relative;
}
.echart-circle{
    width:3.6rem;
    height:2.88rem;
    margin-top:0.24rem;
    background:white;
    overflow:hidden;
}
.showNewDev{
  width:3.6rem;
  height:4.64rem;
  margin-top:0.24rem;
  overflow:hidden;
}
.createDev-log li{
  display:flex;
  justify-content:space-between;
  padding:0.11rem 0;
  font-size:0.14rem;
  line-height:0.18rem;
  color:#01A3FF;
}
.createDev-log li:nth-child(odd){
background:  rgba(0,0,0,0.04);
}
.createDev-log{
  margin-top:0.16rem;
  font-weight: 600;
  overflow:auto;
}
.createDev-log li span{
  color: #1d2d4e;
  margin:0 0.05rem;
}
</style>
